import React, {useState} from 'react';
import classnames from 'classnames';
import {FormattedHTMLMessage, FormattedMessage, useIntl} from 'react-intl';
import PhoneInput from 'react-phone-number-input/input';
import { isValidPhoneNumber } from 'react-phone-number-input';
import MessageIfPresent from '@ignitesales/neuro-application/src/components/MessageIfPresent';

const ShareViaSms = ({className, onSubmit, sendTextMessage, initialValue = ''}) => {

  const intl = useIntl();
  const placeHolderId = 'shareViaSms.placeholder';
  const classes = classnames(className, 'shareViaSms');
  const [phoneNumber, setPhoneNumber] = useState(initialValue);
  const [validPhoneNumber, setValidPhoneNumber] = useState(false);

  const onChange = value => {
    setPhoneNumber(value);
    setValidPhoneNumber(isValidPhoneNumber(value));
  };

  const onFormSubmit = () => {
    sendTextMessage(phoneNumber);
    onSubmit();
  };

  const placeholder = intl.formatMessage({ id: placeHolderId });

  return <section className={classes}>
    <MessageIfPresent id='shareViaSms.message'>
      <FormattedHTMLMessage id='shareViaSms.message' tagName='p'/>
    </MessageIfPresent>

    <FormattedMessage id='shareViaSms.label' tagName='label'/>
    <PhoneInput placeholder={placeholder !== placeHolderId ? placeholder : ''} country="US" value={phoneNumber} onChange={onChange} />
    <button type="submit" className="btn btn-primary" disabled={!validPhoneNumber} onClick={onFormSubmit}>
      <FormattedMessage id='shareViaSms.button' />
    </button>
  </section>;
};

export default ShareViaSms;
